import { Numeric8Icon } from './Numeric8Icon';

/**
 * author: GreenTurtwig
 * id F92BFF4C-3D23-466A-BBE6-AF98DB0F43A9
 * name numeric-8
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-8.svg
 * tags
 * - Alpha / Numeric 
 */
export const NumericEightIcon = Numeric8Icon;
export default NumericEightIcon